import { type FC } from "react";

import clsx from "clsx";
import "./GenericTabs.scss";

export interface TabType {
  text: string;
  onClick: () => void;
  spanText?: string;
  value: string;
}

interface GenericTabsProps {
  tabs: TabType[];
  chosenTab: string;
}

export const GenericTabs: FC<GenericTabsProps> = ({ tabs, chosenTab }) => {
  return (
    <div className="tabs-container">
      {tabs.map((tab) => {
        return (
          <div key={tab.text}>
            <button
              className={clsx("tab", chosenTab === tab.value && "chosen")}
              onClick={tab.onClick}
            >
              {tab.text}{" "}
              {tab.spanText && (
                <span className="span-text">{tab.spanText}</span>
              )}
            </button>
            {chosenTab === tab.value && <div className="line"> </div>}
          </div>
        );
      })}
    </div>
  );
};
